import { render, staticRenderFns } from "./trainingDetail.vue?vue&type=template&id=7b47ce4f&scoped=true&"
import script from "./trainingDetail.vue?vue&type=script&lang=js&"
export * from "./trainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainingDetail.vue?vue&type=style&index=0&id=7b47ce4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47ce4f",
  null
  
)

export default component.exports